.stages-container {
    display: flex;
    flex-direction: row;
    margin-left: 16px;
}
